import Vuex, { GetterTree } from 'vuex';
import { EssayState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<EssayState, RootState> = {
  selectedEssayTheme: (state, getters) => {
    return state.essayTheme;
  },
  availableEssayThemes: (state, getters) => {
    return state.availableEssayThemes;
  },
  essay: (state, getters) => {
    return state.essay;
  },
};

export default getters;
